import parsePhoneNumber from 'libphonenumber-js';

const getParsedPhoneNumber = (phone: string): string => {
  try {
    const phoneNumber = parsePhoneNumber(phone, 'JP');

    if (phoneNumber === undefined) {
      throw 'Parameter is not a phone number!';
    }

    if (!phoneNumber?.isValid()) {
      console.log('The phone format is incorrect, please try again.');

      return phone;
    }

    return phoneNumber
      .formatInternational()
      .replace('+', '')
      .replace(/\s/g, '');
  } catch (error) {
    console.warn(
      "Unable to parse the phone number with unexpected format, maybe it's too long? Using the original input phone number."
    );

    return phone;
  }
};

export { getParsedPhoneNumber };
